import React from 'react';
import {
  Marker,
  InfoWindow,
  useGoogleMap,
  InfoWindowProps,
} from '@react-google-maps/api';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import BoxInfoWindow from './BoxInfoWindow';
import { Box } from 'home/useBoxes';
import useStatus from 'home/useStatus';
import { AppPath } from 'AppRoutes';
import { useNavigate } from 'react-router-dom';
import { useBoxParams } from 'home/useBoxParams';

interface Props {
  box: Box;
}

export const getMarkerIcon = (fillColor: string) => {
  const icon = {
    path:
      'M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z',
    fillColor,
    fillOpacity: 1,
    scale: 2.5,
    strokeColor: 'white',
    strokeWeight: 1,
    anchor: new google.maps.Point(12, 23),
  };
  return icon;
};

const BoxMarker = ({ box }: Props) => {
  const map = useGoogleMap();

  const status = useStatus(box.id);

  const { isSelected, setBoxIdParam } = useBoxParams(box.id);

  const fillColor = !status.isOnline
    ? grey[500]
    : status.isUnlocked
    ? red[500]
    : green[500];

  const icon = getMarkerIcon(fillColor);

  const navigate = useNavigate();

  const onMarkerSelected = () => setBoxIdParam();

  const onDomReady: InfoWindowProps['onDomReady'] = () => {
    if (map) {
      if (map.getZoom() < 17) map.setZoom(17);
      setTimeout(() => {
        map.panTo(box.coords);
      }, 10);
    }
  };

  const onInfoWindowClose = () => navigate(AppPath.Home);

  return (
    <Marker
      onClick={onMarkerSelected}
      position={box.coords}
      title={box.name}
      icon={icon}
    >
      {isSelected ? (
        <InfoWindow onDomReady={onDomReady} onCloseClick={onInfoWindowClose}>
          <BoxInfoWindow box={box} status={status} />
        </InfoWindow>
      ) : null}
    </Marker>
  );
};

export default BoxMarker;
